import type { ClientEventType, TrackEventRequest } from '@sea-wars/protocol';
import { api } from './api/client.js';

/**
 * Zdarzenie produktowe — fire-and-forget. Analityka nigdy nie może zepsuć UI: awaria
 * zapisu (sieć, serwer) jest po prostu utraconym wierszem, nie błędem widocznym graczowi.
 */
export function track(
  type: ClientEventType,
  options: { gameId?: string; props?: TrackEventRequest['props'] } = {},
): void {
  void api.trackEvent(type, options).catch(() => {});
}
